/**
 * External dependencies
 */
import inherits from 'inherits';

export default class SupportPlan {
    
    constructor(cscom) {
        if (!(this instanceof SupportPlan)) {
            return new SupportPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/support-plans/list', null, data);
    }

}
